import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1304.824 345.002L1223.574 426.251 1700.04 902.833 0 902.833 0 1017.755 1700.04 1017.755 1223.574 1494.22 1304.824 1575.47 1920 960.293z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconArrowRightLine = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowRightLine, _Component);

  var _super = _createSuper(IconArrowRightLine);

  function IconArrowRightLine() {
    _classCallCheck(this, IconArrowRightLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowRightLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowRight",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconArrowRightLine.displayName = "IconArrowRightLine";
  return IconArrowRightLine;
}(Component);

IconArrowRightLine.glyphName = 'arrow-right';
IconArrowRightLine.variant = 'Line';
IconArrowRightLine.deprecated = true;
IconArrowRightLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowRightLine;
export { IconArrowRightLine };